<script>
  import { format } from 'svelte-i18n';
  import { Table } from '@sveltestrap/sveltestrap';

  import Status from './status.svelte';

  export let errors = [];
  export let headers = [];
  export let rows = [];

  $: rowErrors = errors?.reduce((result, { row, message }) => {
    if (!result[row]) {
      result[row] = [];
    }
    result[row].push(message);

    return result;
  }, {});
</script>

<div class="scrollable-table my-3">
  <Table bordered class="m-0" responsive={false} size="sm">
    <colgroup>
      <col style="width: 2.25rem;" />
    </colgroup>
    <thead>
      <tr class="table-header">
        <th class="text-center"></th>
        {#each headers as header, n}
          <th class="text-nowrap">
            {header}
          </th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each rows as row, n}
        <tr class:table-danger={rowErrors[n]}>
          <th class="text-center">
            <Status error={rowErrors[n]} />
          </th>
          {#each headers as column}
            <td class:text-danger={rowErrors[n]}>
              {#if rowErrors[n] && row[column] === undefined}
                <i>
                  {$format('label.CSV_PREVIEW_MISSING_COLUMN')}
                </i>
              {:else}
                {row[column]}
              {/if}
            </td>
          {/each}
        </tr>
      {/each}
    </tbody>
  </Table>
</div>

<style lang="scss" src="./csv-preview.scss"></style>
